import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import React from 'react';
import PropTypes from 'prop-types';
import { ListItem } from '@webteam/list';
import classnames from 'classnames/bind';
import localNames from './index.pcss.js';
import CheckboxControl from './parts/checkbox-control.js';

var cn = _bindInstanceProperty(classnames).call(classnames, localNames);

var Checkbox = React.forwardRef(function Checkbox(_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'nude' : _ref$mode,
      size = _ref.size,
      theme = _ref.theme,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      onClick = _ref.onClick,
      error = _ref.error,
      restProps = _objectWithoutProperties(_ref, ["children", "className", "disabled", "mode", "size", "theme", "onMouseEnter", "onMouseLeave", "onClick", "error"]);

  return React.createElement(React.Fragment, null, React.createElement(ListItem, {
    tag: 'label',
    mode: mode,
    size: size,
    theme: theme,
    disabled: disabled,
    className: className,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    icon: React.createElement(CheckboxControl, _extends({
      ref: ref,
      disabled: disabled,
      size: size,
      theme: theme,
      error: Boolean(error),
      notUseLabelTag: true
    }, restProps))
  }, children), error && typeof error !== 'boolean' && React.createElement("div", {
    className: cn('wt-checkbox__error-message', 'wt-checkbox__error-message_single', 'wt-text-3'),
    "data-test": "checkbox-error-message"
  }, error));
});
Checkbox.propTypes = {
  /** Checked state. `onChange` callback is required. */
  checked: PropTypes.bool,

  /** Node or text to show near the input */
  children: PropTypes.node,

  /** Is checkbox initially checked */
  defaultChecked: PropTypes.bool,

  /** Input name attribute */
  name: PropTypes.string,

  /** Appearance theme */
  theme: PropTypes.oneOf(['light', 'dark']),

  /** Disabled state */
  disabled: PropTypes.bool,

  /** Error state */
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),

  /** Value of the checkbox */
  value: PropTypes.string,

  /** Change value callback. `value => ...` */
  onChange: PropTypes.func,

  /** Focus input callback */
  onFocus: PropTypes.func,

  /** Blur input callback */
  onBlur: PropTypes.func,

  /** Indeterminate state */
  indeterminate: PropTypes.bool,
  mode: PropTypes.oneOf(['nude', 'cell']),
  size: PropTypes.oneOf(['xs', 's', 'm'])
};
Checkbox.inputType = 'checkbox';

export { Checkbox, Checkbox as default };
